import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.875}
      d="M9.473 18.314h-.421C5.684 18.314 4 17.472 4 13.262v-4.21C4 5.684 5.684 4 9.052 4h6.736c3.367 0 5.052 1.684 5.052 5.052v4.21c0 3.368-1.684 5.052-5.052 5.052h-.421a.854.854 0 0 0-.674.336l-1.263 1.684c-.556.741-1.465.741-2.02 0l-1.264-1.684c-.134-.185-.446-.336-.673-.336Z"
    />
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.875}
      d="M8.21 9.052h8.42m-8.42 4.21h5.052"
    />
  </svg>
);
export default SvgChat;
